<template>
  <div class="modelDownload">
    <div class="listSearchBox">
      <el-input v-model="modelName" placeholder="模型名称"></el-input>
      <el-select
        v-model="typeFirstUuid"
        placeholder="一级分类"
        @change="changeItemList"
      >
        <el-option
          v-for="(item, index) in groupList"
          :key="index"
          :label="item.name"
          :value="item.uuid"
        >
        </el-option>
      </el-select>
      <el-select v-model="typeSecondUuid" placeholder="二级分类">
        <el-option
          v-for="(item, index) in itemList"
          :key="index"
          :label="item.name"
          :value="item.uuid"
        >
        </el-option>
      </el-select>
      <el-button class="searchBtn" @click="getModelOrderList">搜索</el-button>
      <el-button type="text" class="resetBtn" @click="reset">
        <i class="iconfont icon-qingchushujuku"></i>
        <span>清除条件</span>
      </el-button>
    </div>
    <div class="listTableBox">
      <div class="tableTool">
        <div class="toolLeft">
          <span
            >已选：
            <span class="num">{{ multipleSelection.length }}</span></span
          >
          <el-button
            type="primary"
            plain
            size="small"
            :disabled="multipleSelection.length <= 0"
            @click="handleBatchDownload('all')"
            >批量下载</el-button
          >
        </div>
      </div>
      <div class="tableContent">
        <ul class="tableHeader">
          <li class="select">
            <el-checkbox
              v-model="tableHeaderCheck"
              @change="tableHeaderChange"
            ></el-checkbox>
          </li>
          <li class="name">模型名称</li>
          <li class="classify">一级分类</li>
          <li class="classify">二级分类</li>
          <li class="status">作者</li>
          <li class="status">金额</li>
          <li class="operation">操作</li>
        </ul>
        <ul class="tableBody" v-if="modelOrderList.length != 0" v-loading="loading">
          <li
            class="bodyItem"
            v-for="(item, index) in modelOrderList"
            :key="index"
          >
            <div class="itemTop">
              <el-checkbox
                v-model="item.checked"
                @change="bodyItemCheckChange"
              ></el-checkbox>
              <span
                >上传时间：{{
                  item.orderBase == null ? "" : item.orderBase.createDate
                }}</span
              >
            </div>
            <div class="itemBottom">
              <div class="name">
                <img :src="item.modelImg" alt="" />
                <span>{{ item.modelName }}</span>
              </div>
              <div class="classify">{{ item.typeFirstName }}</div>
              <div class="classify">{{ item.typeSecondName }}</div>
              <div class="status">
                <img :src="item.userImg" alt="" />
                <p>{{ item.modelCreatorName }}</p>
              </div>
              <div class="status">{{ item.price }}</div>
              <div class="operation">
                <el-button type="text" size="small" @click="handPreview(item)"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleBatchDownload(item.uuid)"
                  >下载</el-button
                >
                <!--<el-button type="text" size="small" @click="handDetails"-->
                  <!--&gt;查看订单</el-button-->
                <!--&gt;-->
              </div>
            </div>
          </li>
        </ul>
        <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div>
      </div>
      <el-pagination
        v-if="modelOrderList.length != 0"
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>
    <model-management-dialog
      ref="dialogRef"
      @submit="init"
    ></model-management-dialog>
    <model-details ref="dialogDetails"></model-details>
    <!-- 3d预览 -->
    <three-d
      ref="threeBox"
      :innerVisible="innerVisible"
      :fileListNew="fileListNew"
      @closeDlog="closeDlog"
    ></three-d>
  </div>
</template>

<script>
import {
  getModelOrderList,
  getModelDetail,
  getDictionaryGroup,
  getDictionaryItem,
} from "../../utils/interface";
import { downLoad } from "../../utils/downLoadModel";
import modelManagementDialog from "./modelManagementDialog";
import modelDetails from "./modelDetails";
import threeD from "../../components/threeD/index";

export default {
  name: "modelDownload",
  data() {
    return {
      loading: true,
      modelName: "",
      typeFirstUuid: "",
      typeSecondUuid: "",
      tableHeaderCheck: false,
      modelOrderList: [
        {
          uuid: "0",
          checked: false,
          url: require("@/assets/images/13哆啦A梦.png"),
          name: "创意座椅",
          firstClassify: "家居用品",
          secondClassify: "家具",
          author: "ALICE",
          money: "免费",
          createDate: "2021/08/02 13:37:25",
        },
        {
          uuid: "0",
          checked: false,
          url: require("@/assets/images/13哆啦A梦.png"),
          name: "创意座椅",
          firstClassify: "家居用品",
          secondClassify: "家具",
          author: "ALICE",
          money: "免费",
          createDate: "2021/08/02 13:37:25",
        },
        {
          uuid: "0",
          checked: false,
          url: require("@/assets/images/13哆啦A梦.png"),
          name: "创意座椅",
          firstClassify: "家居用品",
          secondClassify: "家具",
          author: "ALICE",
          money: "免费",
          createDate: "2021/08/02 13:37:25",
        },
        {
          uuid: "0",
          checked: false,
          url: require("@/assets/images/13哆啦A梦.png"),
          name: "创意座椅",
          firstClassify: "家居用品",
          secondClassify: "家具",
          author: "ALICE",
          money: "免费",
          createDate: "2021/08/02 13:37:25",
        },
        {
          uuid: "0",
          checked: false,
          url: require("@/assets/images/13哆啦A梦.png"),
          name: "创意座椅",
          firstClassify: "家居用品",
          secondClassify: "家具",
          author: "ALICE",
          money: "免费",
          createDate: "2021/08/02 13:37:25",
        },
        {
          uuid: "0",
          checked: false,
          url: require("@/assets/images/13哆啦A梦.png"),
          name: "创意座椅",
          firstClassify: "家居用品",
          secondClassify: "家具",
          author: "ALICE",
          money: "免费",
          createDate: "2021/08/02 13:37:25",
        },
      ],
      multipleSelection: [],
      groupList: [],
      itemList: [],
      pageNo: 1,
      total: 0,
      pageSize: 4,
      innerVisible: false,
      fileListNew: [],
    };
  },
  components: {
    modelManagementDialog,
    modelDetails,
    threeD,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.reset();
      this.pageNo = 1;
      this.getModelOrderList();
      this.getGroup();
    },
    getGroup() {
      getDictionaryGroup({ parentCode: "MODEL_CATEGORIES" }).then((res) => {
        this.groupList = res;
      });
    },
    changeItemList() {
      this.typeSecondUuid = "";
      getDictionaryItem({ groupUuid: this.typeFirstUuid }).then((itemList) => {
        this.itemList = itemList;
      });
    },
    // 检索重置
    reset() {
      this.modelName = "";
      this.orderNo = "";
      this.typeFirstUuid = "";
      this.typeSecondUuid = "";
      // this.modelStatus = ''
      this.createDate = null;
    },
    getModelOrderList() {
      this.loading = true
      let params = {
        typeFirstUuid: this.typeFirstUuid,
        typeSecondUuid: this.typeSecondUuid,
        modelName: this.modelName,
        orderNo: this.orderNo,
        modelStatus: this.modelStatus == 0 ? "" : this.modelStatus,
        createDate:
          this.createDate == null
            ? null
            : this.createDate.getFullYear() +
              "-" +
              (this.createDate.getMonth() + 1) +
              "-" +
              this.createDate.getDate(),
        current: this.pageNo,
        pageSize: this.pageSize,
        isBuy: true,
      };
      getModelOrderList(params).then((res) => {
        this.modelOrderList = res.list;
        this.total = res.total;
        console.log(this.modelOrderList);
        this.loading = false
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getModelOrderList();
    },
    async handleBatchDownload(val) {
      let uuidArr = [];
      let name = "";
      if (val === "all") {
        name = "模型";
        this.multipleSelection.map((item) => {
          console.log(item);
          uuidArr.push(item.modelUuid);
        });
      } else {
        name = this.modelOrderList.filter((res) => res.uuid === val)[0]
          .modelName;
        uuidArr.push(
          this.modelOrderList.filter((res) => res.uuid === val)[0].modelUuid
        );
      }
      let data = [];
      try {
        for (let i = 0; i < uuidArr.length; i++) {
          let uuid = uuidArr[i];
          await getModelDetail({ uuid: uuid }).then((res) => {
            console.log(res);
            res.urlList.map((file) => {
              if (file.fileType === "FILE") {
                let obj = {};
                obj.name = file.name;
                obj.url = file.url;
                data.push(obj);
              }
            });
          });
        }
      } catch (e) {
      } finally {
        downLoad(
          data,
          name +
            new Date()
              .toLocaleString()
              .replace(/年|月|日|上午|下午|:| |\//g, "") +
            ".zip"
        );
      }
    },
    // 列表选择功能
    tableHeaderChange(val) {
      this.modelOrderList.map((item) => {
        item.checked = val;
      });
      if (val) {
        this.multipleSelection = this.modelOrderList;
      } else {
        this.multipleSelection = [];
      }
    },
    bodyItemCheckChange(val) {
      this.multipleSelection = this.modelOrderList.filter(
        (res) => res.checked === true
      );
      if (this.multipleSelection.length === this.modelOrderList.length) {
        this.tableHeaderCheck = true;
      } else {
        this.tableHeaderCheck = false;
      }
    },
    // 编辑/新增
    toDialog(type, id) {
      this.$refs.dialogRef.init(type, id);
    },
    // 详情
    handDetails() {
      this.$refs.dialogDetails.init();
    },
    // 预览模型
    handPreview(info) {
      this.$refs.threeBox.threeAnimal(info);
      this.innerVisible = !this.innerVisible;
    },
    closeDlog(index) {
      this.innerVisible = index;
    },
  },
};
</script>

<style scoped lang="less">
.modelDownload {
  padding: 20px;
  .listSearchBox {
    display: flex;
    flex-wrap: wrap;

    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
      margin-bottom: 22px;
    }
  }
  .listTableBox {
    .tableTool {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .toolLeft {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.847);

        .num {
          color: #356fdf;
        }

        button {
          padding: 0;
          margin-left: 15px;
          width: 80px;
          height: 30px;
          background: rgba(242, 244, 247, 1);
          box-sizing: border-box;
          border: 1px solid rgba(21, 126, 251, 1);
          border-radius: 5px;
          font-size: 12px;
          color: #157efb;
          line-height: 30px;
          text-align: center;

          &:hover {
            background: #157efb;
            box-sizing: border-box;
            border: 1px solid #157efb;
            color: #fff;
          }
        }
      }

      .toolRight {
        button {
          width: 83px;
          height: 30px;
          background: rgba(21, 126, 251, 1);
          border: none;
          border-radius: 15px;
          font-size: 13px;
          color: #fff;

          i {
            padding-right: 5px;
          }

          &:hover {
            background: #61a2f0;
          }
        }
      }
    }
    .tableContent {
      // min-width: 1535px;
      .orderNomesaage {
          color: #888;
          text-align: center;
          padding: 15px 0;
      }
      .tableHeader {
        display: flex;
        width: 100%;
        height: 35px;
        line-height: 35px;
        background: #f2f4f9;
        border-radius: 5px;
        margin: 0 0 15px;
        li {
          padding: 0 10px;
          font-size: 14px;
          color: #333333;
          white-space: nowrap;
        }
      }
      .tableBody {
        li {
          width: 100%;
          border: 1px solid #f2f2f2;
          border-radius: 10px;
          font-size: 14px;
          color: #333333;
          margin-bottom: 10px;
          .itemTop {
            width: 100%;
            height: 36px;
            background: #f2f4f9;
            line-height: 36px;
            font-size: 14px;
            color: #333;
            padding: 0 10px;
            display: flex;
            align-items: center;
            position: relative;
            span {
              padding-left: 20px;
            }
          }
          .itemBottom {
            display: flex;
            align-items: center;
            color: #333;
            font-size: 13px;
            padding: 10px 0;
            .name {
              padding-left: 44px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              img {
                width: 132px;
                height: 90px;
                vertical-align: middle;
              }
              span {
                margin-left: 10px;
              }
            }
          }
        }
      }
      .name {
        flex: 1;
        text-align: left;
      }
      .classify {
        width: 180px;
        text-align: center;
      }
      .status {
        width: 150px;
        text-align: center;
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
      }
      .operation {
        width: 300px;
        text-align: center;
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/model/modelDownload.vue